export const BOARD_WIDTH = 10;
export const BOARD_HEIGHT = 20;
export const INITIAL_SPEED = 800;
export const LEVEL_SPEED_INCREASE = 25;

export const BASE_URL = process.env.PUBLIC_URL || '.';

export const TETROMINOS = {
  I: [[1, 1, 1, 1]],
  J: [[1, 0, 0], [1, 1, 1]],
  L: [[0, 0, 1], [1, 1, 1]],
  O: [[1, 1], [1, 1]],
  S: [[0, 1, 1], [1, 1, 0]],
  T: [[0, 1, 0], [1, 1, 1]],
  Z: [[1, 1, 0], [0, 1, 1]]
};

export const COLORS = {
  I: 'bg-sky-500',
  J: 'bg-indigo-500',
  L: 'bg-orange-500',
  O: 'bg-yellow-300',
  S: 'bg-green-400',
  T: 'bg-purple-400',
  Z: 'bg-red-400'
};

export const PEPPER_SHAPES = {
  Poblano: [
    [0, 1, 1, 1, 0],
    [1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1],
    [0, 1, 1, 1, 0],
    [0, 0, 1, 0, 0]
  ],
  Jalapeno: [
    [0, 0, 1, 0, 0],
    [0, 0, 1, 0, 0],
    [0, 1, 1, 1, 0],
    [0, 1, 1, 1, 0],
    [0, 0, 1, 0, 0]
  ],
  Fresno: [
    [0, 0, 1, 0, 0],
    [0, 1, 1, 1, 0],
    [0, 1, 1, 1, 0],
    [0, 0, 1, 0, 0],
    [0, 0, 1, 0, 0]
  ],
  Habanero: [
    [0, 1, 1, 1, 0],
    [1, 1, 1, 1, 1],
    [1, 1, 1, 1, 1],
    [0, 1, 1, 1, 0],
    [0, 0, 1, 0, 0]
  ]
};

export const PEPPER_COLORS = {
  Poblano: 'bg-green-500',
  Jalapeno: 'bg-lime-500',
  Fresno: 'bg-red-500',
  Habanero: 'bg-orange-500'
};

export const POWER_UPS = {
  SLOW_DOWN: 'SLOW_DOWN',
  CLEAR_ROW: 'CLEAR_ROW',
  CHANGE_NEXT: 'CHANGE_NEXT'
};